// @module ROOM4.CCAProductImageEventOverlay.CCAProductClearanceBanner
define("ROOM4.CCAProductImageEventOverlay.CCAProductClearanceBanner.View", [
  "room4_ccaproductimageeventoverlay_ccaproductclearancebanner.tpl",
  "SCView",
], function (
  room4_ccaproductimageeventoverlay_ccaproductclearancebanner_tpl,
  SCViewModule,
) {
  "use strict";

  var SCView = SCViewModule.SCView;

  function ProductClearanceBannerView(config) {
    SCView.call(this, config);
    this.template =
      room4_ccaproductimageeventoverlay_ccaproductclearancebanner_tpl;
    this.contextDataRequest = ["item"];
  }

  ProductClearanceBannerView.prototype = Object.create(SCView.prototype);
  ProductClearanceBannerView.prototype.constructor = ProductClearanceBannerView;

  ProductClearanceBannerView.prototype.getContext = function () {
    var clearance = this.contextData.item().custitem6;

    return {
      clearance: clearance,
    };
  };

  return ProductClearanceBannerView;
});
